import React, { FC, useState, useEffect, useMemo, ReactNode } from "react";
import styles from "./styles.module.less";
import classnames from "classnames";
import { LaunchpadLayout } from "../../components/LaunchpadLayout/index";
import { useTitle } from "../../hooks/useTitle";
import { UserPageBasic } from "./Basic";
import { UserPageConnection } from "./Connection";
import { UserMfa } from "./Mfa";
import { UserSecurity } from "./Security";
import { UserAuthentication } from "./Authentication";
import { useTranslation } from "react-i18next";
import { PackageType } from "@/config";
import qs from "query-string";
import { useLocation, useNavigate } from "react-router";
import { PSCCHeader } from "@/components/PSCCHeader";
import { IconFont } from "@/components/IconFont";
import { MobileLaunchpadLayout } from "@/components/MobileLaunchpadLayout";
import "antd-mobile/dist/antd-mobile.css";
import { useMediaSize } from "@/hooks/useMediaSize";
import zhanghao from "@/assets/image/icon-zhanghao@2x.png";
import renzheng from "@/assets/image/icon-renzheng@2x.png";
import mfa from "@/assets/image/icon-mfa@2x.png";
import anquan from "@/assets/image/icon-anquan@2x.png";
// import { useAuthingTranslation } from "@/hooks/useAuthingTranslation";
import { i18n } from "@/locales";

const allMenus = [
  {
    key: "basic",
    label: (
      <>
        <IconFont type="authing-user-smile-line" />
        {i18n.t("user.personalInfo")}
      </>
    ),
  },
  {
    key: "authenticationInfo",
    label: (
      <>
        <img src={renzheng} alt={i18n.t("user.authenticationInfo")} />
        <IconFont type="authing-award-line" />
        {i18n.t("user.authenticationInfo")}
      </>
    ),
  },
  {
    key: "connection",
    label: (
      <>
        <img src={zhanghao} alt={i18n.t("login.accBind")} />
        <IconFont type="authing-Identity-line" />
        {i18n.t("login.accBind")}
      </>
    ),
  },
  {
    key: "mfa",
    label: (
      <>
        <img src={mfa} alt={i18n.t("user.mfaBind")} />
        <IconFont type="authing-lock-line" />
        {i18n.t("user.mfaBind")}
      </>
    ), //原本这里使用的 at
  },
  {
    key: "security",
    label: (
      <>
        <img src={anquan} alt={i18n.t("user.securityRank")} />
        <IconFont type="authing-shield-check-line" />
        {i18n.t("user.securityRank")}
      </>
    ),
  },
];

export const NavList = React.createContext<
  { key: string; label: React.ReactNode; onClick: () => void }[]
>([]);
export const UserPage: FC = () => {
  const { t } = useTranslation();
  const { isPhoneMedia } = useMediaSize();
  const [user, setUser] = useState(window.__user__);
  const location = useLocation();
  const nav = useNavigate();

  useTitle(t("common.personalCenter"), "");

  const pages: { [key: string]: any } = {
    basic: (
      <UserPageBasic
        onUpdate={() => {
          setUser(window.__user__);
        }}
      />
    ),
    connection: <UserPageConnection />,
    mfa: <UserMfa />,
    security: <UserSecurity />,
    authenticationInfo: <UserAuthentication />,
  };

  const mobilePage: { [key: string]: ReactNode } = {
    basic: (
      <>
        <PSCCHeader user={user} />
        <UserPageBasic
          onUpdate={() => {
            setUser(window.__user__);
          }}
        />
      </>
    ),
    connection: <UserPageConnection />,
    mfa: <UserMfa />,
    security: <UserSecurity />,
    authenticationInfo: <UserAuthentication />,
  };

  const menus = useMemo(() => {
    let menus: { key: string; label: React.ReactNode; onClick: () => void }[] =
      allMenus.map((item) => ({
        ...item,
        onClick: () => {
          nav(
            `/u?${qs.stringify({
              ...qs.parse(location.search),
              user_active_tab: item.key,
            })}`
          );
        },
      }));
    let c = window.__config__;
    let condition1 = !(
      c?.packageType === PackageType.BUS || c?.userPoolInWhitelist === true
    );
    let condition2 = !c?.userPortal?.enableAuthentication;

    if (condition1 || condition2) {
      menus = menus.filter((i) => i.key !== "authenticationInfo");
    }
    const personalCenterMenu = c.userPortal?.personalCenterMenu;

    if (personalCenterMenu && personalCenterMenu.length !== 0) {
      menus = menus.filter((item) => personalCenterMenu.includes(item.key));
    }
    return menus;
  }, [location.search, nav]);

  const current = useMemo(() => {
    return (qs.parse(location.search).user_active_tab as string) || "basic";
  }, [location.search]);

  const isFirstPage = useMemo(
    () => current === menus[0]?.key,
    [current, menus]
  );

  useEffect(() => {
    if (!window.__user__) {
      window.location.href = "/login";
      return;
    }
  }, []);

  return (
    <NavList.Provider value={menus}>
      {!isPhoneMedia ? (
        <LaunchpadLayout>
          <div className={styles.PSCLayout}>
            <PSCCHeader user={user} />
            <div className={classnames(styles.card, styles.cardRight)}>
              {pages[current]}
            </div>
          </div>
        </LaunchpadLayout>
      ) : (
        <MobileLaunchpadLayout
          pageTitle={t("common.personalCenter")}
          isFirstPage={isFirstPage}
          navToFirstPage={() =>
            nav(
              `/u?${qs.stringify({
                ...qs.parse(location.search),
                user_active_tab: menus[0].key,
              })}`
            )
          }
        >
          {mobilePage[current]}
        </MobileLaunchpadLayout>
      )}
    </NavList.Provider>
  );
};
